import BaseAPI from './base'

class SchoolExamPeriodAPI extends BaseAPI {}

export default new SchoolExamPeriodAPI('v1/school-exam-periods', 'SchoolExamPeriod')
